// import { useEffect } from "react";
// import axios from "axios";

// export const Logout = () => {
//   useEffect(() => {
//     (async () => {
//       try {
//         const refreshToken = localStorage.getItem("refresh_token");

//         if (!refreshToken) {
//           console.error("No refresh token found");
//           return;
//         }

//         // Send logout request to the backend
//         const { data } = await axios.post(
//           "http://localhost:8000/logout/",
//           { refresh_token: refreshToken },
//           {
//             headers: {
//               "Content-Type": "application/json",
//             },
//             withCredentials: true,  // Ensure cookies are sent if required
//           }
//         );

//         // Logout successful, clear local storage and reset axios defaults
//         console.log("Logout successful:", data);
//         localStorage.removeItem("access_token"); // Explicitly remove access token
//         localStorage.removeItem("refresh_token"); // Explicitly remove refresh token
//         axios.defaults.headers.common["Authorization"] = null; // Remove authorization header
        
//         // Redirect to login page
//         window.location.href = "/login";
//       } catch (error) {
//         console.error("Logout failed:", error.response?.data || error.message);
//       }
//     })();
//   }, []);

//   return <div>Logging out...</div>;
// };

// export default Logout;


import { useEffect } from "react";
import axios from "axios";
import AccountPage from './UserAccountPage';
import { API_URL } from '../services/api';

export const Logout = () => {
  useEffect(() => {
    (async () => {
      const refreshToken = localStorage.getItem("refresh_token");

      // Always clear tokens and redirect regardless of the server response
      const clearSession = () => {
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        axios.defaults.headers.common["Authorization"] = null;
        window.location.href = "/login";
      };

      if (!refreshToken) {
        console.error("No refresh token found");
        clearSession();
        return;
      }

      try {
        
        await axios.post(
          `${API_URL}logout/`,
          { refresh_token: refreshToken },
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          }
        );
      } catch (error) {
        console.error("Logout error:", error.response?.data || error.message);
      } finally {
        // Clear tokens and redirect, even if the logout request fails
        clearSession();
      }
    })();
  }, []);

  return <div>Logging out...</div>;
};

export default Logout;
